/**
 * @name FloatingLabelSelect
 * @extends FloatingLabelInput
 * @desc Floating labels for <select> elements.
 * @author kari
 * @example
 * ```
 * <floating-label-select>
 *  <label class="control-label">My Label</label>
 *  <select class="form-control">...</select>
 * </floating-label-select>
 * ```
 */

import FloatingLabelInput from 'tc/modules/subcomponents/floating-label/floating-label-input';
let FloatingLabelSelect = Object.create(FloatingLabelInput);

FloatingLabelSelect._attachedCallback = FloatingLabelInput.attachedCallback;

FloatingLabelSelect.attachedCallback = function attachedCallback() {
    this._attachedCallback();
    this.classList.add('floating-label-select');

    // [CHK-265][kari] UX wants to override the baseline default styles for <select>,
    // so that they animate the same as text inputs if there is no value. We're making
    // this opt-in, so that we can possibly roll this back up to baseline.
    if (this.dataset.hasOwnProperty('hasDefaultValue')) {
        this.classList.add('has-default-value');
    }
};

export default FloatingLabelSelect;
